import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { normalizeMsisdn } from '../../sim.utils';

@Component({
  selector: 'mprd-sim-physical',
  templateUrl: './sim-physical.component.html',
})
export class SimPhysicalComponent {
  msisdn: string;

  constructor(private route: ActivatedRoute) {
    this.msisdn = normalizeMsisdn(this.route.snapshot.params.msisdn);
  }
}
